module.exports = __webpack_public_path__ + "static/sport/logo.2004ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/logo.png
// module id = Eeky
// module chunks = 0